<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 16px;padding: 10px;box-shadow: 0 8px 24px rgba(0, 37, 62, 0.12);">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o programa:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="beneficiario.programaId" :items="programas" item-text="nome" item-value="id" color="#00695C" no-data-text="Nenhum programa disponível" @input="pegaProgramaSelecionado"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="programaSelecionado.detalhes">
                      <v-alert type="warning" icon="info">{{ programaSelecionado.detalhes }}</v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados do membro:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light disabled v-model="membro.celula" label="CÉLULA" outlined color="#00695C" required dense hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados da inscrição:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense :disabled="!membro.nome" v-model="beneficiario.sexo" :items="sexos" hide-details item-text="nome" item-value="id" color="#00695C" label="SEXO"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light :disabled="!membro.nome" v-model="beneficiario.whatsApp" label="WHATSAPP" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block color="#00695C" rounded style="border-radius: 28px;" large @click="salvaInscricao">Confirmar Cadastro</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>

        <!-- Exibir dados do beneficiário após a inscrição -->
        <v-row v-if="beneficiario.membroId">
          <v-col cols="12">
            <v-card flat style="border-radius: 16px;box-shadow: 0 8px 24px rgba(0, 37, 62, 0.12);">
              <v-card-title>Beneficiário Cadastrado</v-card-title>
              <v-card-text>
                <p><strong>Nome:</strong> {{ membro.nome }}</p>
                <p><strong>Celula:</strong> {{ membro.celula }}</p>
                <p><strong>Sexo:</strong> {{ beneficiario.sexo }}</p>
                <p><strong>WhatsApp:</strong> {{ beneficiario.whatsApp }}</p>
                <p><strong>Programa:</strong> {{ programaSelecionado.nome }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <!-- FIM INSCRIÇÃO -->

      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: { Snackbar, Loading, },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      igreja: {},
      user: {},
      membro: {
        nome: '',
        celula: '',
        cpf: '',
        id: '',
      },
      beneficiario: {
        nome: '',
        cpf: '',
        sexo: '',
        programaId: '',
        membroId: '',
        igrejaId: '',
        whatsApp: '',
      },
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      condicoes: [
        { value: true, text: 'SIM'},
        { value: false, text: 'NÂO'},
      ],
      sexos: ['MASCULINO', 'FEMININO'],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      programas: [],
      programaSelecionado: [],
      dictionary: {
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },
  
  mounted: function () {
    this.carregaDados()
    this.carregaCelulas()
    this.carregaProgramas()
  },
  
  watch: {
    dialogoNaoCadastrado(val) {
      if (val == false) {
        window.location.reload()
      }
    }
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
        if (response.data) {
          this.igreja = response.data
          this.beneficiario.igrejaId = response.data.id
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },

    async carregaProgramas() {
      await axios.post(baseApiUrl + 'Programas/listarPublicos', null, { params: { igrejaId: this.idIgreja } })
      .then(response => {
        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            if (moment(this.formatDateHora(response.data[i].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
              this.programas.push(response.data[i])
            }
          }
        }
      })
    },

    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPublicas', null, { params: { igrejaId: this.idIgreja } })
      .then(response => {
        if (response.data) {
          this.celulas = response.data
        }
      })
    },

    async consultaCPF(cpf) {
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf } })
      .then(response => {
        if (response.data && response.data.id) {
          this.membro.nome = response.data.nome
          this.beneficiario.nome = response.data.nome
          this.membro.celula = response.data.celula && response.data.celula.nome
            ? response.data.celula.nome
            : this.nomeCelula(response.data.celulaId)
          this.beneficiario.cpf = response.data.cpf
          this.beneficiario.membroId = response.data.id
          this.beneficiario.whatsApp = response.data.telefone
          this.beneficiario.sexo = response.data.sexo
        } else {
          this.dialogoNaoCadastrado = true
        }
        this.isLoading = false
      })
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async salvaInscricao() {
      var vm = this
      if (!this.beneficiario.nome || !this.beneficiario.sexo || !this.beneficiario.programaId || !this.beneficiario.membroId || !this.beneficiario.whatsApp) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos para continuar!", "ATENÇÃO")
      } else {
        this.isLoading = true
        if (await this.verificaInscricaoCpf(this.beneficiario.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Já existe uma inscrição do membro informado para a Escola Ministerial Ser Livre", "ATENÇÃO")
          this.isLoading = false
        } else {
          await axios.post(baseApiUrl + 'beneficiarios/salvarPublico', this.beneficiario)
          .then(response => {
            if (response.data) {
              this.dialogoCadastroConcluido = true
              this.isLoading = false
            }
          })
        }
      }
    },

    nomeCelula(celulaId) {
      let nomeCelula
      this.celulas.filter(celula => {
        if (celula.id === celulaId) {
          nomeCelula = celula.nome.trim()
        }
      })
      return nomeCelula
    },

    async verificaInscricaoCpf(cpf) {
      let existeInscricao
      await axios.post(baseApiUrl + 'beneficiarios/verificaExistencia', null, { params: { cpf: cpf, programaId: this.beneficiario.programaId } })
      .then(response => {
        if (!response.data || response.data.existe === false || response.data.count == 0) {
          existeInscricao = false
        } else {
          existeInscricao = true
        }
      })
      return existeInscricao
    },

    pegaProgramaSelecionado() {
      for (let i = 0; i < this.programas.length; i++) {
        if (this.programas[i].id == this.beneficiario.programaId) {
          this.programaSelecionado = this.programas[i]
        }
      }
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
